<form class="full-width-form">
  <mat-form-field>
    <input matInput name="to_email" [(ngModel)]="toEmail" placeholder="{{translate.instant('CONTACT.RECIPIENT')}}"
           readonly="true"
           class="full-width">
  </mat-form-field>
  <mat-form-field>
    <input matInput name="from_email" [(ngModel)]="fromEmail" placeholder="{{translate.instant('CONTACT.SENDER')}}"
           readonly="true"
           class="full-width">
  </mat-form-field>
  <mat-form-field>
    <input matInput name="subject" [(ngModel)]="subject" placeholder="{{translate.instant('CONTACT.SUBJECT')}}"
           class="full-width">
  </mat-form-field>
</form>
<label for="content">{{translate.instant('CONTACT.CONTENT')}}</label><br>
<textarea id="content" name="content" style="width:100%;" rows="30" [(ngModel)]="content"></textarea>
